import { render, staticRenderFns } from "./RecordPayment.vue?vue&type=template&id=2f2499fe&scoped=true&"
import script from "./RecordPayment.vue?vue&type=script&lang=js&"
export * from "./RecordPayment.vue?vue&type=script&lang=js&"
import style0 from "./RecordPayment.vue?vue&type=style&index=0&id=2f2499fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2499fe",
  null
  
)

export default component.exports